<template>
<div class="menu-button"
     @click="onClickButton"
     :id="btnDivId">
    <div class="menu-icon"></div>
</div>
</template>

<script lang="ts">
import {computed, defineComponent, PropType, ref} from "vue";

export default defineComponent({
    name: "MenuButton",
    props: {
        keyAsId: {
            type: String,
            required: true
        },
        data: {
            type: Object,
            required: true
        },
        onClick: {
            type: Function as PropType<(data: any, btnDiv: HTMLDivElement) => void>,
            required: true
        }
    },
    setup(props) {

        const btnDivId = computed<string>(() => {
            return `btn_div_${props.keyAsId}`
        })

        const onClickButton = () => {

            const btnDiv = document.getElementById(btnDivId.value) as HTMLDivElement

            if (btnDiv) {
                props.onClick(props.data, btnDiv)
            }
        }

        return {
            onClickButton,
            btnDivId,
        }

    }
})
</script>

<style scoped lang="scss">
.menu-button {
    position: relative;
    width: 30px;
    height: 30px;

    &:hover {
        opacity: 0.7;
    }

    &:active {
        opacity: 0.5;
    }

    .menu-icon {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        background-color: gray;
        width: 4px;
        height: 4px;
        border-radius: 2px;

        &::before {
            content: "";
            position: absolute;
            top: 0;
            left: -8px;
            background-color: gray;
            width: 4px;
            height: 4px;
            border-radius: 2px;
        }

        &::after {
            content: "";
            position: absolute;
            top: 0;
            left: 8px;
            background-color: gray;
            width: 4px;
            height: 4px;
            border-radius: 2px;
        }
    }
}
</style>